import { render, staticRenderFns } from "./MyMoreStudies.vue?vue&type=template&id=58f5072d&"
import script from "./MyMoreStudies.vue?vue&type=script&lang=js&"
export * from "./MyMoreStudies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports